var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53846 19.8718C9.53846 20.309 9.18077 20.6667 8.74359 20.6667H0.794872C0.357692 20.6667 0 20.309 0 19.8718V11.9231C0 11.4859 0.357692 11.1282 0.794872 11.1282H8.74359C9.18077 11.1282 9.53846 11.4859 9.53846 11.9231V19.8718Z",
    fill: "#39B586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 19.8718C20.6666 20.309 20.3089 20.6667 19.8718 20.6667H11.923C11.4859 20.6667 11.1282 20.309 11.1282 19.8718V11.9231C11.1282 11.4859 11.4859 11.1282 11.923 11.1282H19.8718C20.3089 11.1282 20.6666 11.4859 20.6666 11.9231V19.8718Z",
    fill: "#39B586"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.923 -1.04904e-05H19.8718C20.3089 -1.04904e-05 20.6666 0.357682 20.6666 0.794862V8.74358C20.6666 9.18076 20.3089 9.53845 19.8718 9.53845H11.923C11.4859 9.53845 11.1282 9.18076 11.1282 8.74358V0.794862C11.1282 0.357682 11.4859 -1.04904e-05 11.923 -1.04904e-05Z",
    fill: "#39B586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74359 9.53845H0.794872C0.357692 9.53845 0 9.18076 0 8.74358V0.794862C0 0.357682 0.357692 -1.04904e-05 0.794872 -1.04904e-05H8.74359C9.18077 -1.04904e-05 9.53846 0.357682 9.53846 0.794862V8.74358C9.53846 9.18076 9.18077 9.53845 8.74359 9.53845Z",
    fill: "#39B586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/DashboardActive.fcffbe4a6dc6d78538561c18717a8c75.svg";
export { ForwardRef as ReactComponent };